import React from "react";
import styled from "styled-components";
import { TextSection } from "@domain/lms/course/courseSection";
import { DraftRenderer } from "@ui/components/containers/draftRenderer";

interface TextSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: TextSection;
}
export const TextSectionView: React.FC<TextSectionViewProps> = ({ section, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<DraftRenderer content={section.content} />
		</Container>
	);
};

const Container = styled.div`
	padding-left: 40px;
	@media (max-width: 900px) {
		padding-left: 20px;
	}
	${({ theme }) => theme.textStyles.primary};
	line-height: 24px;
`;
